import styled, { css } from 'styled-components';
import { RowItemProps, RowProps } from './row.interface';

// Row

const Row = styled.div<RowProps>`
  ${({ theme: { dir }, justify, align, flex, width }) => css`
    display: flex;
    flex-direction: ${dir === 'rtl' ? 'row-reverse' : 'row'};
    justify-content: ${justify};
    align-items: ${align};
    flex: ${flex};
    ${width ? `width: ${width}px` : 'width: 100%'};
  `}
`;

Row.defaultProps = {
  align: 'stretch',
  justify: 'flex-start',
  flex: 'unset',
  width: null,
};

// Row Item

const RowItem = styled.div<RowItemProps>`
  ${({ theme: { space }, flex, width, gap }) => css`
    ${flex ? `flex: ${flex};` : ''}
    ${width ? `min-width: ${width}px` : ''};
    ${width ? `max-width: ${width}px` : ''};

    &:not(&:last-child) {
      ${gap ? `margin-inline-end: ${gap === 'small' ? space.md : gap === 'medium' ? space.lg : gap === 'large'};` : gap}
    }
  `}
`;

RowItem.defaultProps = {
  flex: '1',
  width: null,
  gap: 'small',
};

export default Row;
export { RowItem };
